module.exports = __webpack_public_path__ + "static/screenshot4-3f056cdca2c3f16038eafdb71bbb1619.png";